module.exports = __webpack_public_path__ + "img/text-over-image.632ebc6a.svg";